import { BACKEND_URL } from '../config';

/**
 * Build absolute URLs for /api/uploads/* (avatars, branding, editor media).
 * Uses the same backend origin as the rest of the app (see src/config.js).
 */
export function getApiOrigin() {
  let raw = BACKEND_URL || '';
  raw = String(raw).trim().replace(/\/+$/, '');
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw) && /\/api$/i.test(raw)) {
    return raw.slice(0, -4).replace(/\/+$/, '');
  }
  return raw;
}

export function resolveUploadAssetUrl(storedUrl) {
  if (!storedUrl || typeof storedUrl !== 'string') return '';
  const origin = getApiOrigin();
  if (!origin) return storedUrl;

  const s = storedUrl.trim();
  try {
    const u = s.startsWith('http://') || s.startsWith('https://')
      ? new URL(s)
      : new URL(s, `${origin}/`);
    const path = u.pathname + u.search + u.hash;
    if (path.includes('/api/uploads/')) {
      return `${origin}${path}`;
    }
    return storedUrl;
  } catch {
    if (s.startsWith('/api/uploads/')) return `${origin}${s}`;
    return storedUrl;
  }
}
